/**
 * 提示语编辑器组件
 * 职责: 提示语编辑UI
 */
import React from 'react';
import { Form, Input, Switch, Space, Alert, FormInstance } from 'antd';
import { CodeOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface PromptEditorProps {
    form: FormInstance;
    loading?: boolean;
    onSave: (values: any) => void;
}

export const PromptEditor: React.FC<PromptEditorProps> = ({ form, loading, onSave }) => {
    return (
        <>
            <style>{`
                .full-height-form-item {
                    height: 100%;
                    margin-bottom: 0 !important;
                    display: flex;
                    flex-direction: column;
                }
                .full-height-form-item .ant-form-item-control {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                }
                .full-height-form-item .ant-form-item-control-input {
                    flex: 1;
                    height: 100%;
                }
                .full-height-form-item .ant-form-item-control-input-content {
                    flex: 1;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                }
                .full-height-form-item textarea.ant-input {
                    height: 100% !important;
                    resize: none;
                }
            `}</style>
            <div style={{ flex: 1, minHeight: 0, display: 'flex' }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSave}
                    style={{ display: 'flex', flex: 1, width: '100%' }}
                >
                    <div style={{ flex: '0 0 70%', display: 'flex', flexDirection: 'column', padding: 12, borderRight: '1px solid #f0f0f0', minHeight: 0 }}>
                        <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                            <Space>
                                <CodeOutlined />
                                <span style={{ fontWeight: 500 }}>提示语内容 (Prompt)</span>
                            </Space>
                            <Form.Item
                                name="is_active"
                                valuePropName="checked"
                                style={{ marginBottom: 0 }}
                            >
                                <Switch
                                    size="small"
                                    checkedChildren="启用"
                                    unCheckedChildren="禁用"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item
                            name="content"
                            className="full-height-form-item"
                            rules={[{ required: true, message: '请输入提示语内容' }]}
                        >
                            <TextArea
                                rows={40}
                                style={{
                                    flex: 1,
                                    resize: 'none',
                                    fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
                                    fontSize: 13,
                                    lineHeight: 1.6,
                                    padding: 12,
                                    border: '1px solid #d9d9d9',
                                    borderRadius: 4,
                                    minHeight: 800
                                }}
                                placeholder="在此输入提示语模板..."
                            />
                        </Form.Item>
                    </div>

                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 12, background: '#fafafa', minHeight: 0 }}>
                        <div style={{ marginBottom: 8, flexShrink: 0 }}>
                            <Space>
                                <InfoCircleOutlined />
                                <span style={{ fontWeight: 500 }}>可用变量</span>
                            </Space>
                        </div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                            <Alert
                                message="使用 {{variable}} 插入变量"
                                type="info"
                                showIcon
                                style={{ marginBottom: 8, fontSize: 12, padding: '4px 12px', flexShrink: 0 }}
                            />
                            <Form.Item
                                name="variables"
                                className="full-height-form-item"
                            >
                                <TextArea
                                    rows={40}
                                    style={{
                                        flex: 1,
                                        resize: 'none',
                                        fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
                                        fontSize: 12,
                                        background: '#fff',
                                        color: '#666',
                                        minHeight: 800
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};



